import { Api } from '@/infrastructure';
import { ResponseChatWithMeta } from '@/types';
import { useCallback } from 'react';

type UseOrderChatHook = {
  fetchChats: (orderId: number, beforeId?: number) => Promise<ResponseChatWithMeta>;
};

export const useOrderChat = (): UseOrderChatHook => {
  const fetchChats = useCallback(async (orderId: number, beforeId?: number): Promise<ResponseChatWithMeta> => {
    const params = beforeId !== undefined ? { beforeId } : {};
    return (await Api.get<ResponseChatWithMeta>(`orders/${orderId}/chats`, 'customer', params)).data;
  }, []);
  return {
    fetchChats,
  };
};
